import { z } from 'zod';
import { approvalStatusSchema, currencySchema, moneySchema, visibilitySchema } from './common.js';
import { permissionKeySchema } from './permissions.js';
export const riskInputSchema = z.object({
    projectId: z.uuid(),
    title: z.string().min(1).max(240),
    description: z.string().min(1).max(10_000),
    category: z.string().min(1).max(100),
    probability: z.number().int().min(1).max(5),
    impact: z.number().int().min(1).max(5),
    mitigation: z.string().max(10_000).default(''),
    ownerId: z.uuid().nullable().default(null),
    dueDate: z.iso.date().nullable().default(null),
    visibility: visibilitySchema.default('internal'),
});
export const decisionInputSchema = z.object({
    projectId: z.uuid(),
    title: z.string().min(1).max(240),
    context: z.string().min(1).max(10_000),
    options: z.array(z.string().min(1).max(2_000)).max(20).default([]),
    recommendation: z.string().max(5_000).default(''),
    approverId: z.uuid().nullable().default(null),
    dueDate: z.iso.date().nullable().default(null),
    visibility: visibilitySchema.default('internal'),
});
export const noteInputSchema = z.object({
    projectId: z.uuid(),
    module: z.enum([
        'capacity',
        'planning',
        'budget',
        'billing',
        'scope',
        'reporting',
        'risk',
        'decision',
    ]),
    content: z.record(z.string(), z.unknown()),
});
export const publicationSnapshotSchema = z.object({
    version: z.number().int().positive(),
    project: z.object({ id: z.uuid(), name: z.string(), key: z.string() }),
    budget: z
        .object({ approved: moneySchema, consumed: moneySchema, remaining: moneySchema })
        .optional(),
    milestones: z.array(z.object({
        id: z.uuid(),
        title: z.string(),
        dueDate: z.iso.date().nullable(),
        status: z.string(),
    })),
    risks: z.array(z.object({ id: z.uuid(), title: z.string(), status: z.string() })),
    decisions: z.array(z.object({ id: z.uuid(), title: z.string(), status: approvalStatusSchema })),
    generatedAt: z.iso.datetime(),
});
/** Minimal project projection shared by the report selector and project workspace. */
export const reportProjectSchema = z.object({
    id: z.uuid(),
    key: z.string(),
    name: z.string(),
    clientName: z.string(),
    currency: currencySchema,
    permissions: z.array(permissionKeySchema),
});
/** JSON representation returned by baseline endpoints after Date serialization. */
export const reportBaselineSchema = z.object({
    id: z.uuid(),
    projectId: z.uuid(),
    version: z.number().int().positive(),
    status: approvalStatusSchema,
    snapshot: z.record(z.string(), z.unknown()),
    storagePath: z.string().nullable(),
    sha256: z
        .string()
        .regex(/^[a-f0-9]{64}$/)
        .nullable(),
    approvedById: z.uuid().nullable(),
    approvedAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
//# sourceMappingURL=governance.js.map